export default __webpack_public_path__ + "static/media/FiraSans-MediumItalic.0de554c4.ttf";